/* istanbul ignore file */
import VueRouter from 'vue-router';
import createRouter from './router';
import createStore from './store';
import App from './App';

function createApp({ Vue, Vuex, data = {}, isSSR = true } = {}) {
  Vue.use(VueRouter);
  Vue.use(Vuex);

  const router = createRouter(VueRouter);
  const store = createStore(Vuex);

  store.replaceState({ server: data });

  const app = new Vue({
    store,
    router,
    data: () => ({
      isSSR,
    }),
    render: h => h(App),
  });

  return {
    app,
    store,
    router,
  };
}

export default createApp;
